import React, { useState } from 'react'; // Importa useState
import './Header.css';
import bertolinLogo from '../logo/bertolinsolucoes.png'; // Importa a logo

function Header() {
  const [isOpen, setIsOpen] = useState(false); // Estado para controlar a abertura/fechamento do menu

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <nav className="navbar">
        <a href="/" className="logo-container">
          <img src={bertolinLogo} alt="Bertolin Soluções Logo" className="site-logo" />
        </a>

        {/* Botão de Menu Hambúrguer */}
        <div className={`menu-toggle ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        {/* Links de Navegação */}
        <ul className={`nav-links ${isOpen ? 'open' : ''}`}> {/* Adiciona a classe 'open' dinamicamente */}
          <li><a href="#servicos" onClick={toggleMenu}>Serviços</a></li> {/* Fecha o menu ao clicar */}
          <li><a href="#contato" onClick={toggleMenu}>Contato</a></li> {/* Fecha o menu ao clicar */}
        </ul>
      </nav>
    </header>
  );
}

export default Header;